import { useQuery } from "@tanstack/react-query";
import Router from "..";

export const useNotices = (type, page = 1) => {
  return useQuery({
    queryKey: ["notices", type, page],
    queryFn: async () => {
      const data = await Router.Api.getNoticeList({ type, page });
      return data;
    },
  });
};
